import styled from 'styled-components'

export const Container = styled.p`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
`

export const Title = styled.p`
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`

export const Subtitle = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
  /* Ensure inline tooltips don't break the paragraph flow */
  [data-testid='Tooltip'] {
    display: inline-flex;
    align-items: center;
  }
`
